import {createSlice} from '@reduxjs/toolkit';

const clientSlice = createSlice({
    name:"client",
    initialState:{
        user:null,
        loggedIn:false,
        _id:"628c8a3c7640243d911a6ca7",
        name:"Prepseed Prepare",
        pottal:"lms",
        clientType:"coaching",
        moderators:[
            "628c8acef993173d7fcfb0e2"
        ],
        logo:"https://s3.ap-south-1.amazonaws.com/prepleaf/prod/ldoc/annoucements/u/621b22867a308b0cd42661a6/Lonmvv3n3iUHvW0mAEQ8xhRn/Prepseed Logos.png"
    },
    reducers:{
        loginUser: (state,action)=>{   
            state.user = action.payload;
        },
    }
})

export const {loginUser} = clientSlice.actions;
export default clientSlice.reducer